var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col"},[_c('div',{staticClass:"font-bold"},[_vm._v(" "+_vm._s(_vm.addressTypeDisplay)+" ")]),(_vm.addressData)?_c('div',[_c('span',{staticClass:"ml-4",class:{
        'text-sm': _vm.smallFont === true,
      }},[_vm._v(" "+_vm._s(_vm.addressDisplay)+" ")])]):_c('div',[_c('span',{staticClass:"ml-4 text-gray-300"},[_vm._v("---")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }